export interface TokenSelection {
  isTestnet: boolean;
  chain: string;
  mintId: number;
  symbol: string;
  decimals: number;
  /** USD dollars as a decimal string. */
  usdPrice: string;
}

const SELECTION_KEY = 'cheddar-demo.selection';

function normalizeStoredUsdPrice(value: unknown): string | null {
  if (typeof value === 'string' && value.trim() !== '') return value;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return null;
}

export function loadSelection(): TokenSelection | null {
  try {
    const raw = localStorage.getItem(SELECTION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as TokenSelection;
    if (
      typeof parsed?.mintId !== 'number' ||
      typeof parsed.chain !== 'string' ||
      typeof parsed.symbol !== 'string' ||
      typeof parsed.isTestnet !== 'boolean'
    ) {
      return null;
    }
    const usdPrice = normalizeStoredUsdPrice(parsed.usdPrice);
    if (usdPrice == null) return null;
    return { ...parsed, usdPrice };
  } catch {
    return null;
  }
}

export function saveSelection(selection: TokenSelection): void {
  localStorage.setItem(SELECTION_KEY, JSON.stringify(selection));
}

export function clearSelection(): void {
  localStorage.removeItem(SELECTION_KEY);
}

export const SELECTION_STORAGE_KEY = SELECTION_KEY;
